const pageNameKey = "gatewayServiceUsersListView";

export const gatewayServiceUsersListViewEn = {
  [pageNameKey]: {
    subtitle: "Gateway Users List",
    errorMessage: "Failed to load gateway service users",
  },
};

export const gatewayServiceUsersListViewPtBr = {
  [pageNameKey]: {
    subtitle: "Lista de usuários do gateway",
    errorMessage: "Falha ao carregar os usuários do serviço de gateway",
  },
};

export const gatewayServiceUsersListViewDe = {
  [pageNameKey]: {
    subtitle: "Gateway-Benutzer Liste",
    errorMessage: "Fehler beim Laden der Gateway-Dienstbenutzer",
  },
};

export const gatewayServiceUsersListViewZhHans = {
  [pageNameKey]: {
    subtitle: "网关用户列表",
    errorMessage: "加载网关服务用户失败",
  },
};

export const gatewayServiceUsersListViewIt = {
  [pageNameKey]: {
    subtitle: "Elenco utenti gateway",
    errorMessage: "Impossibile caricare gli utenti del servizio gateway",
  },
};

export const gatewayServiceUsersListViewEs = {
  [pageNameKey]: {
    subtitle: "Lista de usuarios del gateway",
    errorMessage: "No se pudieron cargar los usuarios del servicio de gateway",
  },
};

export const gatewayServiceUsersListViewNl = {
  [pageNameKey]: {
    errorMessage: "Fout bij het laden van de gateway-servicegebruikers",
    subtitle: "Lijst met gatewaygebruikers",
  },
};

export const gatewayServiceUsersListViewTr = {
  [pageNameKey]: {
    errorMessage: "Ağ geçidi hizmeti kullanıcıları yüklenemedi",
    subtitle: "Ağ Geçidi Kullanıcı Listesi",
  },
};
